<template>
  <Tooltip side="bottom" :side-offset="8" :delay-duration="400">
    <button
      type="button"
      class="text-accent-400 hover:bg-neutral-50/[0.12] py-2 px-3 inline-flex"
      @click="onExportButton"
    >
      <Download class="size-6" />
    </button>

    <template #content>
      <p>Export project</p>
    </template>
  </Tooltip>
</template>

<script setup>
import { useStore } from 'vuex';
import { Download } from 'lucide-vue-next';
import { Tooltip } from '@ui/components/tooltip';

const store = useStore();

const onExportButton = () => {
  store.dispatch('application/modals/setExportModal', { value: true });
};
</script>
